import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { useLanguage } from '../../context/LanguageContext';
import './Header.css';
import logo from '../../assets/HeaderPictures/headerImg1.png';

const Header = () => {
  const { lang, setLang } = useLanguage();
  const location = useLocation();

  const content = {
    en: {
      home: "Home",
      start: "Getting started",
      courses: "All Courses",
      faq: "faq",
      about: "About",
      updates: "Stay Updated",
      contact: "Contact Us"
    },
    jp: {
      home: "ホーム",
      start: "詳しくはこちら",
      courses: "コース紹介",
      faq: "よくある質問",
      about: "会社概要",
      updates: "最新情報",
      contact: "お問い合わせ"
    }
  };

  const t = content[lang];

  if (location.pathname === '/') return null;

  return (
    <Navbar collapseOnSelect expand="lg" variant="dark" className="custom-header sticky-top">
      <Container fluid className="px-5">

        {/* 1. Logo */}
        <Navbar.Brand as={Link} to="/">
          <img src={logo} alt="Level 9 Logo" className="header-logo" />
        </Navbar.Brand>

        {/* 2. Mobile Toggler (Sada će biti bele boje zbog variant="dark") */}
        <Navbar.Toggle aria-controls="headerNav" />

        {/* 3. Collapsible Content */}
        <Navbar.Collapse id="headerNav">
          <Nav className="mx-auto">
            <Nav.Link as={Link} to="/" className={location.pathname === '/' ? 'active-link' : ''}>
              {t.home}
            </Nav.Link>
            <Nav.Link as={Link} to="/getting-started" className={location.pathname === '/getting-started' ? 'active-link' : ''}>
              {t.start}
            </Nav.Link>
            <Nav.Link as={Link} to="/courses" className={location.pathname === '/courses' ? 'active-link' : ''}>
              {t.courses}
            </Nav.Link>
            <Nav.Link as={Link} to="/faq" className={location.pathname === '/faq' ? 'active-link' : ''}>
              {t.faq}
            </Nav.Link>
            <Nav.Link as={Link} to="/about" className={location.pathname === '/about' ? 'active-link' : ''}>
              {t.about}
            </Nav.Link>
            {/* <Nav.Link as={Link} to="/stay-updated" className={location.pathname === '/stay-updated' ? 'active-link' : ''}>
              {t.updates}
            </Nav.Link> */}
            <Nav.Link as={Link} to="/contact" className={location.pathname === '/contact' ? 'active-link' : ''}>
              {t.contact}
            </Nav.Link>
          </Nav>

          {/* 4. Language Selector (Vidljiv i u meniju na mobilnom) */}
          <div className="header-lang-picker d-flex align-items-center justify-content-center">
            <button
              className={`lang-link ${lang === 'en' ? 'active' : ''}`}
              onClick={() => setLang('en')}
            >
              EN
            </button>
            <span className="divider">|</span>
            <button
              className={`lang-link ${lang === 'jp' ? 'active' : ''}`}
              onClick={() => setLang('jp')}
            >
              JP
            </button>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;